import React from 'react'
import { lazy } from 'app/lazy'
import { useAppDispatch, useAppSelector } from 'app/state'
import { closeDialog } from 'features/dialogs/state/dialogsSlice'
import { styled } from '@mui/material'
import { DialogModel } from './types'

const Container = styled('div')(() => ({
  position: 'absolute'
}))

const Dialog = React.memo(
  (dialog: DialogModel) => {
    const dispatch = useAppDispatch()

    const Dialog = lazy(() => dialog.factory())

    return (
      <React.Suspense key={dialog.name} fallback={<div />}>
        <>
          <Dialog
            open={true}
            name={dialog.name}
            onClose={() => dispatch(closeDialog(dialog.name))}
            {...dialog.dialogProps}
          />
        </>
      </React.Suspense>
    )
  },
  // Redux is only used to pass props from nested hierarchy component to top level (RootDialogs).
  // As all the props are passed using dispatch(showDialog) this is why
  // there is no that those props can change once the dialog is opened.
  // As the props won't change once the dialog is opened we can use aggressive memorization.
  // Aggressive memorization will solve issue when modal is re-renderend.
  // e.g. When Dialog is open on top of another dialog.
  () => true
)

function RootDialogs() {
  const dialogs = useAppSelector((state) => state.dialogs)

  if (!dialogs.length) return null

  return (
    <Container>
      {dialogs.map((dialog) => (
        <Dialog key={dialog.name} name={dialog.name} dialogProps={dialog.dialogProps} factory={dialog.factory} />
      ))}
    </Container>
  )
}

export default RootDialogs
